var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTecton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_3702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05392 5.84314C8.53108 3.74369 10.3774 3.40808 12.8986 4.83909L12.9752 4.88299L20.256 9.0959L21.7432 6.51442L23.999 7.81973L19.2072 16.1376L16.9513 14.8323L18.949 11.3646L11.6682 7.15167C9.64741 5.98237 9.11085 7.17101 7.90763 9.50693L7.87096 9.57806L7.86297 9.57349L7.79921 9.68419L5.58067 8.40047L7.05392 5.84314ZM4.79278 9.45779L7.04864 10.7631L5.05096 14.2308L12.3318 18.4437C14.3526 19.613 14.8891 18.4243 16.0924 16.0884L16.129 16.0173L16.137 16.0219L16.2008 15.9112L18.4193 17.1949L16.9461 19.7522C15.4689 21.8517 13.6225 22.1873 11.1014 20.7563L11.0248 20.7124L3.744 16.4994L2.25684 19.0809L0.0009829 17.7756L4.79278 9.45779Z",
    fill: "#D30602"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_3702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTecton);
export default __webpack_public_path__ + "static/media/Tecton.04f1b3d7ca995b96fc359c81742a1cdc.svg";
export { ForwardRef as ReactComponent };